import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import PolicyClasses from "./index.module.css";
import { Helmet } from "react-helmet";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { Services } from "Services";
import { SuccessSwal, warningSwal } from "Util/Toast";
import ReactLoading from "react-loading";
import MainLoader from "Components/loader/loader";
window.Buffer = window.Buffer || require("buffer").Buffer;

const POLICY_LABELS = {
    Privacy_Policy: "Privacy Policy",
    Terms_and_Conditions: "Terms and Conditions",
    Refund_Policy: "Refund Policy",
};

function AddPolicy() {
    const { PolicyType } = useParams();
    const [loading, setLoading] = useState(false);
    const [mainLoad, setMainLoad] = useState(true);
    const Navigate = useNavigate();
    const {
        handleSubmit,
        reset,
        control,
        formState: { errors },
    } = useForm({ defaultValues: { Content: "" } });
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        Services.getPolicyByType("GET", null, token, PolicyType)
            .then((response) => {
                setTimeout(() => {
                    setMainLoad(false);
                }, 200);
                if (response.Status === 1 && response.Policy) {
                    reset({ Content: response.Policy.Content || "" });
                }
            })
            .catch((err) => {
                setMainLoad(false);
                alert("something went wrong please try again");
                console.log(err);
            });
        // eslint-disable-next-line
    }, [PolicyType]);

    const onSubmit = (data) => {
        const payload = {
            PolicyType,
            Content: data.Content,
        };

        setLoading(true);
        Services.updatePolicy("PUT", JSON.stringify(payload), token, PolicyType)
            .then((response) => {
                if (response.Status === 1) {
                    Navigate(-1);
                    SuccessSwal("Success", response.Message);
                } else {
                    setLoading(false);
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const backButton = () => {
        Navigate(-1);
    };

    return (
        <Layout Active={"Policy"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Update Policy</title>
            </Helmet>
            {mainLoad && <MainLoader />}
            <div className={PolicyClasses["Container"]}>
                <button onClick={backButton} className={PolicyClasses["back"]}>
                    Back
                </button>
                <div className={PolicyClasses["wrapper"]}>
                    <h3>
                        {`Update ${POLICY_LABELS[PolicyType] || PolicyType}`}
                    </h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={PolicyClasses["form-control-full"]}>
                            <label htmlFor="Content">Content</label>
                            <Controller
                                name="Content"
                                control={control}
                                rules={{
                                    validate: (value) =>
                                        (value && value.trim().length > 0) ||
                                        "This field is required",
                                }}
                                render={({ field }) => (
                                    <Editor
                                        tinymceScriptSrc={
                                            process.env.PUBLIC_URL +
                                            "/tinymce/tinymce.min.js"
                                        }
                                        value={field.value}
                                        onEditorChange={field.onChange}
                                        init={{
                                            license_key: "gpl",
                                            height: 480,
                                            menubar: false,
                                            branding: false,
                                            plugins:
                                                "link image media lists table code",
                                            toolbar:
                                                "undo redo | blocks | bold italic underline | " +
                                                "bullist numlist | link table | code",
                                            valid_elements: "*[*]",
                                            extended_valid_elements: "*[*]",
                                        }}
                                    />
                                )}
                            />
                            {errors.Content && (
                                <span>{errors.Content.message}</span>
                            )}
                        </div>

                        <button disabled={loading}>
                            {loading ? (
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </Layout>
    );
}

export default AddPolicy;
